module.exports = __webpack_public_path__ + "static/media/dashboard.16c64b12.png";